import Api from '@/services/Api'

export default {
  getFabricCategories (token) {
    return Api().get('fabricCategories')
  },

  deleteFabricCategory (fabricCategoryID) {
    return Api().delete('fabricCategory/' + fabricCategoryID)
  }
}



// WEBPACK FOOTER //
// ./src/services/FabricCategoryService.js